export default "__VITE_ASSET__vLv_8EOD__"